export const Links = {
  Welcome: '/',

  ForgotPassword: '/forgotPassword',
  ConfirmChangeEmail: '/confirmChangeEmail',
  EmailConfirmed: '/activate',
  PasswordHasBeenSet: '/setPassword',

  // Only for web
  BrowserNotSupported: '/browserNotSupported',

  //Common
  Privacy: '/privacy',
  PrivacyApp: '/privacy/prismaapp',
  About: '/about',
  Imprint: '/imprint',
};
